// components/SupportersSponsors.js
import React from "react";
import "./SupportersSponsors.css";  

const sponsors = [{ name: "Coming Soon", logo: "./logosmall.PNG", url: "#", showText: true },];
/*[
  { name: "Innovate BC", logo: "/assets/logos/placeholder1.png", url: "#" },
  { name: "Alberta Innovates", logo: "/assets/logos/placeholder2.png", url: "#" },
  { name: "Canada Council for the Arts", logo: "/assets/logos/placeholder3.png", url: "#" },
  { name: "Partner Organization", logo: "/assets/logos/placeholder4.png", url: "#" },
  { name: "University / Lab", logo: "/assets/logos/placeholder5.png", url: "#" },
  { name: "Community Partner", logo: "/assets/logos/placeholder6.png", url: "#" },
];*/

export default function SupportersSponsors() {
  return (
    <section className="sponsors-section">
      <div className="sponsors-container">
        <h3 className="sponsors-title">Supporters & Sponsors</h3>

        <div className="sponsors-marquee">
          {/* left fade */}
          <div className="fade-mask left"></div>

          {/* scrolling content */}
          <div className="sponsors-track">
            {sponsors.map((sponsor, i) => (
              <a
                key={i}
                href={sponsor.url}
                className="sponsor-logo-wrap"
                target="_blank"
                rel="noopener noreferrer"
              >
                {sponsor.logo ? (
                  <img
                    src={sponsor.logo}
                    alt={sponsor.name}
                    className="sponsor-logo"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                ) : null}
                {sponsor.showText && <span className="sponsor-name">{sponsor.name}</span>}
              </a>
            ))}
          </div>

          {/* right fade */}
          <div className="fade-mask right"></div>
        </div>
      </div>
    </section>
  );
}
